import React from "react";
import cls from "./styles.module.scss";

export function LoadingScreen() {
  return (
    <div className={cls.container}>
      <div className={cls.loader}>
        <svg viewBox="0 0 100 100" className={cls.svg}>
          {/* Static ring */}
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke="#FFB800"
            strokeWidth="4"
            strokeLinecap="round"
          />

          {/* Animated ring */}
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke="#FFB800"
            strokeWidth="8"
            strokeLinecap="round"
            className={cls.animatedCircle}
          />
        </svg>
      </div>

      <div className={cls.logo}>
        <h1>БКоннект</h1>
      </div>
    </div>
  );
}
